var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "menu--item_subgroup",
      class: _vm.subgroupClasses,
      attrs: {
        "data-pricing-type-count": _vm.section.ms_group_by_price
          ? 1
          : _vm.pricingTypes.length || 1,
      },
    },
    [
      _vm.section.ms_group_by_price
        ? [
            _vm._l(_vm.pricingTypes, function (pricingType) {
              return [
                _c(
                  "h3",
                  { staticClass: "menu--section_subgroup_title" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.subgroupTitle))]),
                    _vm._v(" "),
                    _c("menu-item-price", {
                      attrs: {
                        "price-to-display": pricingType,
                        "price-label": _vm.items[0]?.price_label || "",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.items, function (item, itemIndex) {
                  return item.mi_price === pricingType
                    ? _c(
                        _vm.getMenuItemComponentOverride(
                          item,
                          _vm.menuItemComponent
                        ),
                        {
                          key: item.mi_id,
                          tag: "component",
                          attrs: {
                            item: item,
                            "pricing-types": [],
                            "is-grouped-by-price":
                              !!_vm.section.ms_group_by_price,
                            "item-index": itemIndex,
                            section: _vm.section,
                            "show-bin": _vm.isBinShowing,
                            "menu-id": _vm.section.menu_id,
                            "tag-location": _vm.menuItemTagLocation,
                          },
                          on: { rows: _vm.handleItemRows },
                        }
                      )
                    : _vm._e()
                }),
              ]
            }),
          ]
        : [
            _vm.subgroupTitle.length ||
            (_vm.section.ms_show_pricing_header && _vm.pricingTypes.length)
              ? [
                  _vm.layout === "title-above"
                    ? [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "menu--section_subgroup_title menu--section_subgroup_title-title_above",
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.subgroupTitle))])]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h3",
                    { staticClass: "menu--section_subgroup_title" },
                    [
                      _vm.layout !== "title-above"
                        ? _c("span", [_vm._v(_vm._s(_vm.subgroupTitle))])
                        : _c("span"),
                      _vm._v(" "),
                      _vm._l(_vm.pricingTypes, function (pricingType) {
                        return _vm.section.ms_show_pricing_header
                          ? _c("span", [_vm._v(_vm._s(pricingType))])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isPageLinkGrid
              ? _c(
                  "div",
                  {
                    staticClass: "viewport",
                    class: _vm.sectionContentClasses(_vm.section),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "body-container-scroller" },
                      _vm._l(_vm.items, function (item, itemIndex) {
                        return _c(
                          _vm.getMenuItemComponentOverride(
                            item,
                            _vm.menuItemComponent
                          ),
                          {
                            key: item.mi_id,
                            tag: "component",
                            attrs: {
                              item: item,
                              "pricing-types": _vm.pricingTypes,
                              "is-grouped-by-price":
                                !!_vm.section.ms_group_by_price,
                              "item-index": itemIndex,
                              section: _vm.section,
                              "show-bin": _vm.isBinShowing,
                              "menu-id": _vm.section.menu_id,
                              "tag-location": _vm.menuItemTagLocation,
                            },
                            on: { rows: _vm.handleItemRows },
                          }
                        )
                      }),
                      1
                    ),
                  ]
                )
              : _vm._l(_vm.items, function (item, itemIndex) {
                  return _c(
                    _vm.getMenuItemComponentOverride(
                      item,
                      _vm.menuItemComponent
                    ),
                    {
                      key: item.mi_id,
                      tag: "component",
                      attrs: {
                        item: item,
                        "pricing-types": _vm.pricingTypes,
                        "is-grouped-by-price": !!_vm.section.ms_group_by_price,
                        "item-index": itemIndex,
                        section: _vm.section,
                        "show-bin": _vm.isBinShowing,
                        "menu-id": _vm.section.menu_id,
                        "tag-location": _vm.menuItemTagLocation,
                      },
                      on: { rows: _vm.handleItemRows },
                    }
                  )
                }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }